<template>
  <div class="property-create">
    <h1 class="center-text">Edit Property</h1>
    <form @submit.prevent="editProperty">
      <div v-if="apiError" class="error center-element">
        Error: {{ apiErrorMessage }}<br />
      </div>
      <div class="form-300 center-element">
        <label>Property Name</label><br />
        <input
          v-model.trim="property.name"
          type="text"
          placeholder="Property Name"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Property Name'"
          required
        /><br />
        <label>Property URL</label><br />
        <input
          v-model.trim="property.url"
          type="text"
          placeholder="Property URL"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Property URL'"
          required
        /><br />
        <button type="submit" class="button button-300">Edit Property</button>
      </div>
    </form>
  </div>
</template>

<script>
import api from "@/api/index";
const apiServiceProperty = new api.APIServiceProperty();

export default {
  data() {
    return {
      property: {
        id: this.$route.params.id,
        name: "",
        url: "",
        email: ""
      },
      apiError: false,
      apiErrorMessage: ""
    };
  },
  created() {
    this.getProperty();
  },
  methods: {
    editProperty: function() {
      this.resetAPIError();
      apiServiceProperty
        .editProperty(this.property)
        .then(data => {
          this.$router.push("/console/dashboard");
        })
        .catch(error => {
          this.setAPIError(error);
        });
    },
    getProperty: function() {
      this.resetAPIError();
      apiServiceProperty
        .getProperty(this.property.id)
        .then(data => {
          console.log(data);
          this.property.name = data.data[0].name;
          this.property.url = data.data[0].url;
        })
        .catch(error => {
          this.setAPIError(error);
        });
    },
    resetAPIError: function() {
      this.apiError = false;
      this.apiErrorMessage = "";
    },
    setAPIError: function(message) {
      this.apiError = true;
      this.apiErrorMessage = message;
    }
  }
};
</script>
